var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGstr2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M60.025 3.973A6.702 6.702 0 0 0 55.253 2H15.82c-2.757 0-5 2.243-5 5v5.36a1 1 0 1 0 2 0V7c0-1.654 1.346-3 3-3h34.638a6.725 6.725 0 0 0-1.959 4.75v45.999a5.255 5.255 0 0 1-5.249 5.249c-1.657.05-3.145-.525-4.168-1.693-1.904-2.134-2.21-5.662-1.861-8.253a1.003 1.003 0 0 0-.991-1.134H12.82v-5.482a1 1 0 1 0-2 0v5.482H3.001a1 1 0 0 0-1 1v3.08c0 4.963 4.037 9 9 9l32.276-.001c3.984-.015 7.222-3.26 7.222-7.248v-39.25h10.5a1 1 0 0 0 1-1V8.75a6.707 6.707 0 0 0-1.974-4.777zM11.001 59.998c-3.86 0-7-3.14-7-7v-2.08h31.128c-.185 3.03.453 6.781 2.807 9.08zM59.999 13.5h-9.5V8.75c0-2.62 2.13-4.75 4.75-4.75 2.561-.054 4.804 2.188 4.75 4.75z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.763 40.64C21.73 40.64 27.4 34.97 27.4 28s-5.67-12.64-12.638-12.64c-6.97 0-12.64 5.67-12.64 12.64s5.67 12.64 12.64 12.64zm0-23.28C20.629 17.36 25.4 22.135 25.4 28S20.63 38.64 14.763 38.64c-5.867 0-10.64-4.774-10.64-10.64s4.773-10.64 10.64-10.64zM31.99 10.396h12.5a1 1 0 1 0 0-2h-12.5a1 1 0 1 0 0 2zM31.99 15.36h12.5a1 1 0 1 0 0-2h-12.5a1 1 0 1 0 0 2zM31.99 20.326h12.5a1 1 0 1 0 0-2h-12.5a1 1 0 1 0 0 2zM31.99 25.29h12.5a1 1 0 1 0 0-2h-12.5a1 1 0 1 0 0 2zM31.99 30.255h12.5a1 1 0 1 0 0-2h-12.5a1 1 0 1 0 0 2zM31.99 35.22h12.5a1 1 0 1 0 0-2h-12.5a1 1 0 1 0 0 2zM25.99 39.185a1 1 0 0 0 1 1h17.5a1 1 0 1 0 0-2h-17.5a1 1 0 0 0-1 1zM44.49 43.15h-20.5a1 1 0 1 0 0 2h20.5a1 1 0 1 0 0-2z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.763 34c1.654 0 3-1.346 3-3s-1.346-3-3-3-3 1.346-3 3 1.345 3 3 3zm0-4a1.001 1.001 0 1 1-1 1c0-.551.448-1 1-1zM9.763 28c1.654 0 3-1.346 3-3s-1.346-3-3-3-3 1.346-3 3 1.345 3 3 3zm0-4a1.001 1.001 0 1 1-1 1c0-.551.448-1 1-1zM13.05 35.906a1 1 0 0 0 1.19-.766l3-13.857a1.001 1.001 0 0 0-.765-1.19 1.004 1.004 0 0 0-1.19.767l-3 13.857c-.116.54.227 1.072.766 1.19z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGstr2);
export default __webpack_public_path__ + "static/media/gstr-2.250fa852b2c264dc9bbf9ae215d5e983.svg";
export { ForwardRef as ReactComponent };